

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------------
//  >>> CHANGE HERE <<<   Pick ONE Latin font (for French + English)
//  Options: "Inter" | "Plus Jakarta Sans" | "Outfit" | "DM Sans"
// ----------------------------------------------------------------------------
//const LATIN_FONT = "Plus Jakarta Sans";
const LATIN_FONT = "DM Sans";
// ----------------------------------------------------------------------------
//  >>> CHANGE HERE <<<   Pick ONE Arabic font
//  Options: "IBM Plex Sans Arabic" | "Cairo" | "Tajawal" | "Noto Kufi Arabic"
// ----------------------------------------------------------------------------
const ARABIC_FONT = "IBM Plex Sans Arabic";

// ----------------------------------------------------------------------------
//  Google Fonts URLs for every option (so any choice above just works)
// ----------------------------------------------------------------------------
const LATIN_GF = {
  "Inter":
    "Inter:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400;1,600",
  "Plus Jakarta Sans":
    "Plus+Jakarta+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400;1,600",
  "Outfit":
    "Outfit:wght@300;400;500;600;700;800",
  "DM Sans":
    "DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400",
};

const ARABIC_GF = {
  "IBM Plex Sans Arabic":
    "IBM+Plex+Sans+Arabic:wght@300;400;500;600;700",
  "Cairo":
    "Cairo:wght@300;400;500;600;700;800",
  "Tajawal":
    "Tajawal:wght@300;400;500;700;800",
  "Noto Kufi Arabic":
    "Noto+Kufi+Arabic:wght@300;400;500;600;700;800",
};

export default function SiteFonts() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  // Inject the Google Fonts <link> once
  useEffect(() => {
    const id = "site-fonts-gf";
    if (document.getElementById(id)) return;

    const families = [LATIN_GF[LATIN_FONT], ARABIC_GF[ARABIC_FONT]]
      .filter(Boolean)
      .map((f) => `family=${f}`)
      .join("&");

    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = `https://fonts.googleapis.com/css2?${families}&display=swap`;
    document.head.appendChild(link);
  }, []);

  // The active font for body text depends on current language
  const activeFont = isArabic ? ARABIC_FONT : LATIN_FONT;

  const css = `
    /* ===== 1. Override the site's font variables ===== */
    :root {
      --default-font: "${activeFont}", system-ui, -apple-system, "Segoe UI", Arial, sans-serif;
      --heading-font: "${activeFont}", system-ui, -apple-system, "Segoe UI", Arial, sans-serif;
      --nav-font:     "${activeFont}", system-ui, -apple-system, "Segoe UI", Arial, sans-serif;
    }

    body, .main, p, span, a, li, button, input, select, textarea, label,
    h1, h2, h3, h4, h5, h6 {
      font-family: var(--default-font);
    }

    /* Headings keep the same family but a bit tighter for a modern look */
    h1, h2, h3, h4, h5, h6 { letter-spacing: -0.01em; }

    /* Arabic: nicer line-height + force the Arabic font on RTL content */
    [dir="rtl"], [dir="rtl"] * {
      font-family: "${ARABIC_FONT}", "Cairo", "Tajawal", sans-serif !important;
    }
    [dir="rtl"] { line-height: 1.85; }

    /* ===== 2. COMPACT MENU — fits more items in the same bar ===== */
    .site-navigation { margin: 0 1rem; }

    .main-menu {
      gap: 0.15rem;                 /* was 1rem  -> much tighter */
      flex-wrap: nowrap;
    }

    .menu-link,
    .menu-trigger {
      padding: 0.5rem 0.6rem;       /* was 0.75rem 1rem */
      font-size: 0.86rem;           /* was 1rem  -> smaller text */
      gap: 0.25rem;                 /* was 0.5rem */
      font-weight: 500;
      letter-spacing: 0.01em;
    }

    .menu-link i,
    .menu-trigger i { font-size: 0.7rem; }

    /* On large screens, allow slightly smaller still if you have many items */
    @media (min-width: 1200px) and (max-width: 1400px) {
      .main-menu { gap: 0.05rem; }
      .menu-link, .menu-trigger {
        padding: 0.5rem 0.45rem;
        font-size: 0.8rem;
      }
    }

    /* Submenus: tidy + readable */
    .submenu .menu-link {
      padding: 0.55rem 1rem;
      font-size: 0.88rem;
      white-space: nowrap;
    }

    /* Arabic menu spacing fix (RTL) */
    [dir="rtl"] .menu-link i,
    [dir="rtl"] .menu-trigger i { margin-right: 4px; margin-left: 0; }
  `;

  return <style>{css}</style>;
}
